var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "check-icon_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#check-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m6.367 9.966 5.578-5.578a.739.739 0 0 1 .54-.228c.21 0 .39.076.542.228a.739.739 0 0 1 .227.54.739.739 0 0 1-.227.542L6.9 11.595a.731.731 0 0 1-.534.228.731.731 0 0 1-.535-.228L2.974 8.736a.717.717 0 0 1-.222-.54.762.762 0 0 1 .234-.541.739.739 0 0 1 .541-.228c.209 0 .389.076.54.228l2.3 2.311Z"
}))));
export default SvgCheckIcon;